import { useCallback, useRef } from 'react';
import { captureAppError } from '@leagueplatform/observability';
import { OnboardingMachineContext } from 'components/onboarding/onboarding.machine';
import { OnboardingFeatureHighlights } from 'components/onboarding-feature-highlights/onboarding-feature-highlights.component';
import { SENTRY_CONSTANTS } from 'common/constants';

// First onboarding step (ON-01). The SDK reports a failed slide fetch through
// the same callback as completion, so a failure advances rather than stranding
// the member on a step they cannot pass.
export const FeatureHighlightsView = () => {
  const { send } = OnboardingMachineContext.useActorRef();
  // The SDK calls this from its render body without returning, so it can fire
  // repeatedly; a second navigateToNextView would skip Account Setup.
  const hasAdvanced = useRef(false);

  const handleComplete = useCallback(
    (error?: Error) => {
      if (hasAdvanced.current) return;
      hasAdvanced.current = true;

      if (error) {
        captureAppError(error, {
          ownershipTeam: SENTRY_CONSTANTS.OWNERSHIP_TEAM,
          errorName: 'Feature highlights failed to load',
        });
      }
      send({ type: 'navigateToNextView' });
    },
    [send],
  );

  return <OnboardingFeatureHighlights onOnboardingComplete={handleComplete} />;
};
